// extracted by mini-css-extract-plugin
export default {"progess":"Progress_progess__jfO98","step":"Progress_step__d5uEk","disabled":"Progress_disabled__0y+91","description":"Progress_description__VdEC-","arrow":"Progress_arrow__iTboG"};